import { defineStyleConfig } from '@chakra-ui/react';

const Textarea = defineStyleConfig({
  variants: {
    outline: (props) => ({
        bg: props.colorMode === 'dark' ? 'gray.900' : 'white',
        borderColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.400',
        _hover: {
            borderColor: props.colorMode === 'dark' ? 'gray.500' : 'gray.500',
        },
        _focusVisible: {
            borderColor: props.colorMode === 'dark' ? 'brand.orange.500' : 'brand.blue.500',
            boxShadow: props.colorMode === 'dark' ? 'focus_admin' : 'focus',
        },
    }),
  },
  defaultProps: {
    variant: 'outline',
  },
});

export default Textarea;